import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { User } from "../../../models/user";
import UserRepository from "../../../repositories/user-repository";
import { UserList } from "../list/interface";

export const useGetUser = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<UserList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [userData, setUserData] = useState<User | null>(null);
  const [isOnFetchingUserData, setIsOnFetchingUserData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await UserRepository.all(params)
      .then((response: AxiosResponse<ICollection<UserList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadUserData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingUserData(true);

      await UserRepository.show(id, params)
        .then((response: AxiosResponse<IResource<User>>) => {
          setUserData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingUserData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadUserData,
    isOnFetchingUserData,
    userData,
  };
};
